import { FETCH_ESCALATIONS_SUCCESS, FETCH_ESCALATIONS_START } from '../actions/actiontypes'

const INIT_STATE = {
	data:{},
	completed:false,
}

export default function(state = INIT_STATE, action) {
	switch(action.type){
		case FETCH_ESCALATIONS_START:{
			return {...state};
		}
		case FETCH_ESCALATIONS_SUCCESS:{
			return {...state, data : action.payload};
		}
		default:
			return state;
	}
}